'use client';

import { FormButtonSelect } from '@/components/form/form-button-select';
import { MultidietPickerFormType } from '@/features/multidiet-picker/types/multidiet-picker-form.type';
import { MultidietSetupSetupType } from '@/features/multidiet-picker/types/multidiet-setup.type';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';

export const MultidietPickerForm = ({
  layout,
  form,
  multidietSetup,
}: {
  layout: 'page' | 'popup';
  form: UseFormReturn<MultidietPickerFormType>;
  multidietSetup: MultidietSetupSetupType | null;
}) => {
  const t = useTranslations();

  return (
    <div
      className={cn('flex flex-col gap-4 items-center justify-center w-full')}
    >
      <div
        className={cn(
          'rounded-xl flex gap-2',
          layout === 'popup' && 'bg-brand-grey1',
        )}
      >
        {multidietSetup && (
          <FormButtonSelect
            fieldName='dietTypeAny'
            actionAfterChange={() => {
              form.setValue('dietType', []);
            }}
            className={cn('flex-row ', layout === 'popup' && ' p-2 pr-0')}
            classNameItem='w-auto'
            classNameFormItem='w-auto '
            multi={false}
            form={form}
            fieldOptions={[
              {
                label: <span>{t(`dietTags.ANY`)}</span>,
                value: 'ANY',
              },
            ]}
          />
        )}
        {multidietSetup && (
          <FormButtonSelect
            fieldName='dietType'
            className={cn(
              'flex-row flex-nowrap',
              layout === 'popup' && 'bg-brand-grey1 rounded-xl p-2 pl-0',
            )}
            classNameItem='w-auto'
            classNameFormItem='w-auto'
            multi={true}
            form={form}
            fieldOptions={multidietSetup.dietTypes
              .filter((tag) => tag.dietTag !== 'ANY')
              .map((tag) => ({
                label: <span>{t(`dietTags.${tag.dietTag}`)}</span>,
                value: tag.dietTag,
              }))}
          />
        )}
      </div>
      {multidietSetup && (
        <FormButtonSelect
          fieldName='calories'
          className={cn(
            'flex-row',
            layout === 'popup' && 'bg-brand-grey1 rounded-xl p-2',
          )}
          classNameItem='w-auto'
          classNameFormItem='w-auto'
          multi={false}
          form={form}
          fieldOptions={multidietSetup.calories.map((calory) => ({
            label: <span>{t('common.kcal', { kcal: calory })}</span>,
            value: calory.toString(),
          }))}
        />
      )}
    </div>
  );
};
